$(function(){
	$(document).on('click', '.js-more', function(e) {
		e.preventDefault();
		var el = $(this);
		var href = el.attr('href');

		el.fadeOut('slow', function () {
			el.parent().remove();
		});

		$.ajax({
			url: href,
			type: "GET",
			success: function(data){
				($(data)).appendTo('.js-more-wrapper').hide().fadeIn('slow');
			}
		});

	});
});
